import { ReactNode } from "react";
import { useAppSelector } from "src/state/store/store";

const AuthenticatedView: React.FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const isLoggedIn: boolean =
    useAppSelector((state) => state.auth.token) != null ? true : false;
  if (!isLoggedIn) return;
  return <>{children}</>;
};
export default AuthenticatedView;
